import Vue from 'vue'
import App from './App.vue'
import store from './assets/js/store'
import Base from './assets/js/base'
import Serve from './assets/js/serve'
import './assets/less/common.less'

Vue.config.productionTip = false;

Vue.prototype.$Base = Base;

Vue.prototype.$Serve = Serve;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
